import ScrollSnapWheel from './ScrollSnapWheel'

interface StorageScrollPickerProps {
  value: string
  onChange: (v: string) => void
  options: readonly string[]
  ariaLabel?: string
  compact?: boolean
}

export default function StorageScrollPicker({
  value,
  onChange,
  options,
  ariaLabel = 'Storage',
  compact = false,
}: StorageScrollPickerProps) {
  return (
    <ScrollSnapWheel
      className="storage-scroll-wheel"
      value={value}
      onChange={onChange}
      items={options}
      ariaLabel={ariaLabel}
      compact={compact}
    />
  )
}
